import { NavLink  } from 'react-router-dom';

export default function NavMaterial() {
  	return (
        <div className="nav-align-top">
            <ul className="nav nav-pills flex-column flex-md-row mb-6">
                <li className="nav-item">
                    <NavLink to="/materials" className="nav-link">
                        <i className="bx me-1_5 bx-map-pin bx-md"></i>
                        Elenco
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to="/categories" className="nav-link">
                        <i className="bx bx-category-alt bx-md"></i>
                        Categorie
                    </NavLink>
                </li>
            </ul>
        </div>
	);
}